export * from './log-details-widget.component';
export * from './fetch-log-details-widget.component';
